export const setLanguage = (language) => ({
    type: 'SET_LANGUAGE',
    payload: language,
  });